
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 1000 1000","version":"1.1"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',{attrs:{"id":"defs4"}}),_c('path',{attrs:{"id":"rect832","transform":"scale(1 -1)","fill":"#000","fill-opacity":"1","stroke":"none","stroke-width":"5.63","stroke-miterlimit":"4","stroke-dasharray":"none","stroke-opacity":"1","d":"M82.347-241.982h259.685v117.819H82.347z"}}),_c('circle',{attrs:{"id":"path877","cx":"453.562","cy":"926.156","r":"30","fill":"#000","fill-opacity":"1","stroke-width":".942","stroke":"none"}}),_c('circle',{attrs:{"id":"path939","cx":"563.966","cy":"925.515","r":"30","fill":"#000","fill-opacity":"1","stroke-width":"1.262","stroke":"none"}}),_c('path',{attrs:{"transform":"scale(1 -1)","id":"rect945","fill":"#000","fill-opacity":"1","stroke":"none","stroke-width":"5.761","stroke-miterlimit":"4","stroke-dasharray":"none","stroke-opacity":"1","d":"M374.555-244.827H634.24v123.377H374.555z"}}),_c('path',{attrs:{"id":"rect947","transform":"scale(1 -1)","fill":"#000","fill-opacity":"1","stroke":"none","stroke-width":"5.799","stroke-miterlimit":"4","stroke-dasharray":"none","stroke-opacity":"1","d":"M661.976-244.827h259.685v125H661.976z"}}),_c('path',{attrs:{"d":"M121 315v56h742v420h84V315z","id":"rect951","fill":"#000","fill-opacity":"1","stroke":"none","stroke-width":"6.667","stroke-miterlimit":"4","stroke-dasharray":"none","stroke-opacity":"1"}}),_c('path',{attrs:{"id":"rect949","opacity":"1","fill":"#000","fill-opacity":"1","stroke":"none","stroke-width":"12.593","stroke-miterlimit":"4","stroke-dasharray":"none","stroke-opacity":".941","d":"M25.021 428H801v431.799H25.021z"}})])
          )
        }
      }
    